<template>
  <div class="pointer-events-auto flex flex-row items-center rounded bg-white p-1 shadow-map">
    <ui-map-control-layer-select />

    <div
      class="hidden flex-row sm:flex"
      :class="{
        '!hidden md:!flex': hazards.activeView === HazardView.Both && windowSize.height.value < 750,
      }"
    >
      <div class="mx-2 h-8 w-px bg-grey-50 transition-all"></div>

      <ui-search-dropdown class="h-8" placeholder="Search type" @update:search="(value) => (search = value)">
        <template #default="{ open, toggleOpen }">
          <ui-map-control-layer-dropdown :open="open" :toggle-open="toggleOpen" icon-name="emergency_home" text="Icons" />
        </template>
        <template #items>
          <ui-dropdown-items :filters="layerSections" :search="search" padding="px-4" :show-clear-filters="false" />
        </template>
      </ui-search-dropdown>

      <div class="mx-2 h-8 w-px bg-grey-50 transition-all"></div>

      <gv-dropdown class="mr-1 h-8">
        <template #default="{ open, toggleOpen }">
          <ui-map-control-layer-dropdown :open="open" :toggle-open="toggleOpen" icon-name="map" text="Guide" />
        </template>
        <template #menu>
          <ui-map-guide />
        </template>
      </gv-dropdown>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { layerSections, useHazardsStore, HazardView } from '@/features';
import { useWindowSize } from '@vueuse/core';
import { ref } from 'vue';

const hazards = useHazardsStore();
const windowSize = useWindowSize();

const search = ref<string>('');
</script>
